export const products = [
    {
        id: 1,
        img: "freelanceMedic",
        link: "https://freelancemedic.com/"
    },
    {
        id: 2,
        img: "emart",
        link: "https://jefferynmose12.github.io/e-mart/"
    },
    {
        id: 3,
        img: "joblisting",
        link: "https://jefferynmose12.github.io/job-listing-app"
    },
    {
        id: 4,
        img: "scratch",
        link: "https://jefferynmose12.github.io/scratch-users-app/"
    },
]